module.exports = __webpack_public_path__ + "static/media/person.7ba41368.svg";